import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, Plus, Search, Filter, MapPin } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { ApproveListingModal } from '../../components/modals/ApproveListingModal';
import { RejectListingModal } from '../../components/modals/RejectListingModal';
import { useNavigate } from 'react-router-dom';
export function PublicListingsPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [selectedListing, setSelectedListing] = useState<any>(null);
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const listings = [{
    id: 'GOV-101',
    loc: 'Sector 45, Gurgaon',
    size: '2.5 Acres',
    purp: 'Commercial',
    status: 'Published'
  }, {
    id: 'GOV-102',
    loc: 'Wakad, Pune',
    size: '15,000 Sq.Ft',
    purp: 'Public Park',
    status: 'Draft'
  }, {
    id: 'GOV-103',
    loc: 'Whitefield, Bangalore',
    size: '1 Acre',
    purp: 'Institutional',
    status: 'Published'
  }, {
    id: 'GOV-104',
    loc: 'Hinjewadi, Pune',
    size: '5000 Sq.Ft',
    purp: 'Residential',
    status: 'Pending Approval'
  }, {
    id: 'GOV-105',
    loc: 'Electronic City, Bangalore',
    size: '3 Acres',
    purp: 'Commercial',
    status: 'Published'
  }];
  const filteredListings = listings.filter(listing => {
    const matchesSearch = listing.id.toLowerCase().includes(searchQuery.toLowerCase()) || listing.loc.toLowerCase().includes(searchQuery.toLowerCase()) || listing.purp.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'All' || listing.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const handleApprove = (listing: any) => {
    setSelectedListing(listing);
    setIsApproveModalOpen(true);
  };
  const handleReject = (listing: any) => {
    setSelectedListing(listing);
    setIsRejectModalOpen(true);
  };
  const handleManage = (listingId: string) => {
    navigate(`/authority/listings/${listingId}`);
  };
  const handlePublishNew = () => {
    navigate('/authority/listings/create');
  };
  return <DashboardLayout title="Authority Portal" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2770">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-2771">
        <div data-id="element-2772">
          <h1 className="text-2xl font-bold mb-1" data-id="element-2773">Public Land Listings</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-2774">
            Manage government land available for public use or sale.
          </p>
        </div>
        <button onClick={handlePublishNew} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2775">
          <Plus className="w-4 h-4" data-id="element-2776" /> Publish New Listing
        </button>
      </div>

      <div className="bg-white border border-gray-300 mb-8" data-id="element-2777">
        <div className="p-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-gray-50" data-id="element-2778">
          <div className="relative w-full md:w-64" data-id="element-2779">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-2780" />
            <input type="text" placeholder="Search listings..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-sm text-sm focus:outline-none focus:border-gray-500" data-id="element-2781" />
          </div>
          <div className="flex gap-2" data-id="element-2782">
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-3 py-2 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2783">
              <option value="All" data-id="element-2784">All Status</option>
              <option value="Published" data-id="element-2785">Published</option>
              <option value="Draft" data-id="element-2786">Draft</option>
              <option value="Pending Approval" data-id="element-2787">Pending Approval</option>
            </select>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-2788">
          <table className="w-full text-left text-sm min-w-[800px]" data-id="element-2789">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-2790">
              <tr data-id="element-2791">
                <th className="p-4 font-bold" data-id="element-2792">Plot ID</th>
                <th className="p-4 font-bold" data-id="element-2793">Location</th>
                <th className="p-4 font-bold" data-id="element-2794">Size</th>
                <th className="p-4 font-bold" data-id="element-2795">Purpose</th>
                <th className="p-4 font-bold" data-id="element-2796">Status</th>
                <th className="p-4 font-bold text-right" data-id="element-2797">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2798">
              {filteredListings.map((item, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-2799">
                  <td className="p-4 font-mono font-bold" data-id="element-2800">{item.id}</td>
                  <td className="p-4 flex items-center gap-2" data-id="element-2801">
                    <MapPin className="w-4 h-4 text-gray-400" data-id="element-2802" />
                    {item.loc}
                  </td>
                  <td className="p-4 font-mono" data-id="element-2803">{item.size}</td>
                  <td className="p-4" data-id="element-2804">{item.purp}</td>
                  <td className="p-4" data-id="element-2805">
                    <span className={`inline-block px-2 py-1 text-xs font-bold rounded border ${item.status === 'Published' ? 'bg-green-100 text-green-800 border-green-200' : item.status === 'Pending Approval' ? 'bg-yellow-100 text-yellow-800 border-yellow-200' : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-id="element-2806">
                      {item.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4 text-right" data-id="element-2807">
                    <div className="flex justify-end gap-2" data-id="element-2808">
                      {item.status === 'Pending Approval' && <>
                          <button onClick={() => handleApprove(item)} className="text-green-600 hover:underline font-bold text-xs" data-id="element-2809">
                            ✓ Approve
                          </button>
                          <button onClick={() => handleReject(item)} className="text-red-600 hover:underline font-bold text-xs" data-id="element-2810">
                            ✗ Reject
                          </button>
                        </>}
                      <button onClick={() => handleManage(item.id)} className="text-blue-600 hover:underline font-bold text-xs" data-id="element-2811">
                        Manage
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {filteredListings.length === 0 && <div className="p-12 text-center text-gray-500" data-id="element-2812">
            <p className="font-mono text-sm" data-id="element-2813">
              No listings found matching your criteria
            </p>
          </div>}
      </div>

      {selectedListing && <>
          <ApproveListingModal isOpen={isApproveModalOpen} onClose={() => setIsApproveModalOpen(false)} listingId={selectedListing.id} listingTitle={`${selectedListing.purp} Plot - ${selectedListing.loc}`} data-id="element-2814" />
          <RejectListingModal isOpen={isRejectModalOpen} onClose={() => setIsRejectModalOpen(false)} listingId={selectedListing.id} listingTitle={`${selectedListing.purp} Plot - ${selectedListing.loc}`} data-id="element-2815" />
        </>}
    </DashboardLayout>;
}